<template>
  <!-- <ChatList v-model:isCollapsed="isCollapsed" :hide-header="true" /> -->
  <div>
    <MateChatList
      v-if="mate"
      :mate="mate"
      :my-mate-id="mateStore.userMate.id"
    />
  </div>
</template>
<script setup lang="ts">
import { Mate } from "@/types/entity";
import { useMate } from "@/stores/mate";
import { onMounted, PropType } from "vue";
import { useChatSession } from "@/stores/chatSession";
const props = defineProps({
  mate: {
    type: Object as PropType<Mate>,
    required: true,
  },
});

const mateStore = useMate();
const chatSessionStore = useChatSession();

onMounted(async () => {
  await chatSessionStore.getOrFetchSessionByMateId(
    props.mate.id,
    true,
    mateStore.userMate.id
  );
});
</script>
